export const endPoints = {
  GET_CUSTOMERS: 'api/customers/get-customers-list',
  GET_ALL_CUSTOMER_TYPES: 'api/posv3/maintenance/get-all-customer-types',
  GET_CUSTOMER_TYPES_ENABLED_FOR_LSP: 'api/customers/get-customer-types-enabled-for-lsp',
  GET_QUALIFYING_CONDITIONS: 'api/posv3/maintenance/get-qualifying-conditions',
  UPDATE_QUALIFYING_CONDITION: 'api/posv3/maintenance/update-qualifying-condition',
  UPDATE_CUSTOMER_TYPES: 'api/posv3/maintenance/update-visible-customer-types',
};
